@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.pointofinterest

import com.narbase.letsgo.router.EndPoint

object GetPointsOfInterestSearchStatusEndpoint :
    EndPoint<GetPointsOfInterestSearchStatusEndpoint.Request, GetPointsOfInterestSearchStatusEndpoint.Response>() {
    class Request

    class Response(
        val isActive: Boolean,
        val url: String,
        val isReachable: Boolean,
        val clusterStatus: String?,
        val indexExists: Boolean,
        val indexedPointsCount: Int,
        val databasePointsCount: Int,
        val error: String?,
    )
}
